import styled, { css } from 'styled-components';
import { ReactComponent as Pix } from '../../assets/icons/pix.svg';
import { ReactComponent as BarCode } from '../../assets/icons/bar-code.svg';
import { ReactComponent as Back } from '../../assets/icons/back-icon-mobile.svg';
import { BiCreditCard } from 'react-icons/all';

interface SelectedProps {
  selected?: boolean;
  haveChildren?: boolean;
  resize?: boolean;
  error?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0 40px 0;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0;
  }
`;

export const Container2 = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: 100%;
  }

  .footer {
    display: flex;
    justify-content: space-between;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 960px) {
    border-radius: 0;
    width: 100%;
    justify-content: flex-start;
  }
`;

export const IconBack = styled(Back)`
  display: none;

  @media screen and (max-width: 960px) {
    display: flex;
    width: 24px;
    height: 24px;
    margin-top: 6px;
  }
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primaryDark2};
  margin-bottom: 28px;

  @media screen and (max-width: 960px) {
    font-size: 24px;
    margin: 3px 0px 28px 15px;
  }
`;

export const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 0 20px 0;

  @media screen and (max-width: 960px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const LoaderDiv = styled.div`
  width: 100%;
  display: flex;
  justify-items: center;
  justify-content:center;
`;

export const Subtitle2 = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 30px;
`;

export const PaymentCard = styled.div`
  width: 100%;
  height: 68px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.8),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin-bottom: 12px;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  .text {
    padding: 6px 0;
    font-size: 20px;
    color: ${(props) => props.theme.colors.black};
    flex-grow: 10;
    @media screen and (max-width: 960px) {
      padding: 10px 0;
    }
  }

  .icon {
    flex-grow: 1;
  }

  @media screen and (max-width: 960px) {
    height: 72px;
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    padding: 18px;

    .text {
      font-size: 16px;
    }
  }
`;

export const SelectContainer = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.selected ? props.theme.colors.primaryDark1 : '#000'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;

  ${(props) =>
    props.error &&
    css`
      border: 2px solid ${props.theme.colors.danger};
    `}

  span {
    background: ${(props) =>
      props.selected ? props.theme.colors.primaryDark1 : 'none'};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;

    ${(props) =>
      props.error &&
      css`
        background: ${props.theme.colors.danger};
      `}
  }
`;

export const IconPix = styled(Pix)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconBarCode = styled(BarCode)`
  width: 28px;
  height: 28px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const IconCreditCard = styled(BiCreditCard)`
  width: 32px;
  height: 32px;
  color: #000;
  margin-right: 5px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const Button = styled.button<{ color: string; loading?: boolean }>`
  height: 60px;
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  text-transform: uppercase;
  padding: ${(props) => (props.loading ? '0 24px' : '19px 24px')};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  font-size: 16px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
